import React from "react";
import ArrowIcon from "../navigation/ArrowIcon";

const TabButtonDropdown = ({
  label = "More",
  tabs = [],
  activeTab,
  handleTabClick,
}) => {
  const [isOpen, setIsOpen] = React.useState(false);

  const handleSelect = (tabName) => {
    handleTabClick(tabName);
    setIsOpen(false);
  };

  // Check if activeTab is one of the dropdown tabs
  const isActive = tabs.some((tab) => tab.tabName === activeTab);

  const dropdownButtonClass =
    "w-full bg-light-2 xs:mx-2 hover:text-buiha-red hover:bg-light-1 " +
    "dark:hover:bg-dark-2 dark:hover:text-dark-5 h-10 xs:rounded-t border-r-2 border-t-2 " +
    "xs:border-x-2 border-light-3 dark:border-dark-3 max-xs:text-xxs xs:max-sm:text-xs ease-in-out duration-200 flex flex-row items-center justify-center " +
    (isActive ? "dark:bg-dark-1 bg-light-1" : "dark:bg-dark-4 bg-light-2");

  return (
    <div
      className="group relative w-28"
      onMouseEnter={() => setIsOpen(true)}
      onMouseLeave={() => setIsOpen(false)}
    >
      <button
        type="button"
        onClick={(e) => {
          e.preventDefault();
          setIsOpen((prev) => !prev);
        }}
        className={
          dropdownButtonClass +
          " dark:group-hover:text-dark-5 light:group-hover:text-buiha-red ease-in-out duration-200"
        }
      >
        <p className="ml-2 dark:group-hover:text-dark-5 light:group-hover:text-buiha-red ease-in-out duration-200">
          {label}
        </p>
        <ArrowIcon />
      </button>

      {isOpen && (
        <div className="w-full xs:mx-2 absolute left-0 bg-white dark:bg-dark-4 border-2 border-light-3 dark:border-dark-3 rounded-b shadow-lg z-50">
          {tabs.map((tab) => (
            <div
              key={tab.tabName}
              onClick={() => handleSelect(tab.tabName)}
              className={`cursor-pointer px-3 py-1 hover:bg-light-2 dark:hover:bg-dark-2 ${
                activeTab === tab.tabName ? "" : ""
              }`}
            >
              <p className="dark:hover:text-dark-5 hover:text-buiha-red ease-in-out duration-200">
                {tab.label}
              </p>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default TabButtonDropdown;
